import axios from 'axios'

const ACCESS_TOKEN_KEY = 'access_token'

export function saveToken(token) {
    localStorage.setItem(ACCESS_TOKEN_KEY, token)
}

function invalidateToken() {
    localStorage.removeItem(ACCESS_TOKEN_KEY)
}

function readToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY)
}

function pushRouterToLogin(to, reason) {
    let query = {}

    if (to !== false) query.redirect = to
    if (reason !== undefined) query.reason = reason
    window.$vue.$router.push({
        path: '/auth/login',
        query: query,
    })
}

function redirectLogin(reason, invalidate = true) {
    if (invalidate) invalidateToken()

    var to = !window.$vue.$route.path.startsWith('/auth')
        ? window.$vue.$route.path
        : false

    if (reason === 'LOGIN_REQUIRED' || reason === 'NO_TOKEN') {
        pushRouterToLogin(to)
    } else {
        pushRouterToLogin(to, reason)
    }
}

function checkTokenValidity() {
    return axios
        .post('/api/auth/check', { token: readToken() })
        .then(resp => {
            if (!resp.data.data.valid) {
                if (!window.$vue.$route.path.startsWith('/auth')) {
                    redirectLogin(resp.data.data.reason)
                }
                return false
            } else return true
        })
        .catch(error => {
            invalidateToken()
            console.error(error.response ? error.response : error)
            return false
        })
}

axios.interceptors.request.use(
    config => {
        let token = readToken()
        if (token !== null) {
            config.headers.authorization = token
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// Codes d'erreur 403 signifiant que la session n'est plus valide.
// Les autres 403 (refus d'une action, droits insuffisants…) sont laissés à
// l'écran qui a fait l'appel : l'utilisateur reste connecté.
const SESSION_ERRORS = [
    'LOGIN_REQUIRED',
    'NO_TOKEN',
    'INVALID_TOKEN',
    'INVALID_USER',
    'EXPIRED_TOKEN',
    'DISABLED_LOGIN',
    'TOKEN_BANNED',
    'BANNED_TOKEN',
    'SESSION_EXPIRED',
    'OUTSIDE_TOKEN_SCOPE',
    'ACCESS_DENIED',
]

// Code d'erreur renvoyé par l'API (enveloppe { success, data: { message } })
export function errorMessage(error) {
    const data = error && error.response && error.response.data
    if (!data) return undefined
    return (data.data && data.data.message) || data.message
}

// On souhaite être notifié des fins de session pour invalider le token
axios.interceptors.response.use(response => response, function (error) {
    if (error.response && error.response.status === 403) {
        const message = errorMessage(error)
        if (message === undefined || SESSION_ERRORS.includes(message)) {
            redirectLogin(message)
        }
    }
    return Promise.reject(error)
})

export const initUser = {
    _id: '',
    name: '',
    surname: '',
    habilitation: '',
    login: '',
    settings: {
    },
    email: '',
}
export default {
    user: {
        authentificated: false,
    },
    isLoggedIn() {
        return readToken() !== null
    },
    login(username, password) {
        return axios.post('/api/auth/login', { username, password }).then(resp => {
            let token = resp.data.data.token
            saveToken(token)
            return resp.data.data
        })
    },
    logout() {
        return axios.post('/api/auth/logout', { token: readToken() }).then(() => {
            invalidateToken()
        })
    },
    checkTokenValidity() {
        return checkTokenValidity(readToken())
    },
}